import React, { useState } from 'react';
import {
  FormDatePicker,
  InlineEditTable,
  FormSwitch,
  ColumnType,
  FormInput,
  Button,
  notification,
  ButtonDelete,
} from '@digital/ui';
import {
  DocumentoAcessorio,
  updateDocumentacaoAcessoriaFornecedor,
  getAllDocumentosAcessorioByDocumentacaoMensal,
  SendDocumentoAcessorio,
  ApproveDocumentoAcessorio,
  ReproveDocumentoAcessorio,
  RemoveFileDocumentoAcessorio,
  download,
} from '@app/api/contrato/documentacaoAcessoriaMensal';
import * as Yup from 'yup';
import { UploadFile } from '@app/components';
import { Tooltip, Table } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import { getLoggedIsMRN } from '@app/helpers';
import PerfectScrollbar from 'react-perfect-scrollbar';

const TableDocumentoMensal = (props: { documentosAcessorio: DocumentoAcessorio[]; documentoMensalId: string }) => {
  const { documentosAcessorio, documentoMensalId } = props;

  const [documentos, setDocumentosAcessorios] = useState(documentosAcessorio);
  const [isMRN] = useState<boolean>(getLoggedIsMRN());

  const handleUpdate = (values: any): any => {
    if (values.aplicabilidade || (!values.aplicabilidade && values.justificativa)) {
      updateDocumentacaoAcessoriaFornecedor(values.formData, values).then(resp => {
        if (resp.valid) {
          getAllDocumentosAcessorioByDocumentacaoMensal(documentoMensalId).then(result => {
            setDocumentosAcessorios(result as DocumentoAcessorio[]);
          });
        }
        return resp;
      });
    } else {
      notification.error('A justificativa deve ser informada.');
    }
  };

  const handleSend = (values: any) =>
    SendDocumentoAcessorio(values.id).then(resp => {
      if (resp.valid) {
        getAllDocumentosAcessorioByDocumentacaoMensal(documentoMensalId).then(result => {
          setDocumentosAcessorios(result as DocumentoAcessorio[]);
        });
      }
      return resp;
    });

  const handleDownloadFile = (values: any) =>
    download(values.localArquivo + '\\' + values.nomeArquivo, values.nomeArquivo);

  const handleApprove = (values: any) =>
    ApproveDocumentoAcessorio(values.id).then(resp => {
      if (resp.valid) {
        getAllDocumentosAcessorioByDocumentacaoMensal(documentoMensalId).then(result => {
          setDocumentosAcessorios(result as DocumentoAcessorio[]);
        });
      }
      return resp;
    });

  const handleReprove = (values: any) =>
    ReproveDocumentoAcessorio(values.id).then(resp => {
      if (resp.valid) {
        getAllDocumentosAcessorioByDocumentacaoMensal(documentoMensalId).then(result => {
          setDocumentosAcessorios(result as DocumentoAcessorio[]);
        });
      }
      return resp;
    });

  const handleRemoveFile = (values: any) =>
    RemoveFileDocumentoAcessorio(values.id).then(resp => {
      if (resp.valid) {
        getAllDocumentosAcessorioByDocumentacaoMensal(documentoMensalId).then(result => {
          setDocumentosAcessorios(result as DocumentoAcessorio[]);
        });
      }
      return resp;
    });

  const columns = [
    {
      title: 'Documento',
      dataIndex: 'documento',
      width: '20%',
    },
    {
      title: 'Status',
      dataIndex: 'documentoAcessorioStatus',
      width: '10%',
    },
    {
      title: 'Validade',
      dataIndex: 'dataValidade',
      type: ColumnType.Date,
      renderEdit: (nome, item) =>
        item.codigoStatus != 3 ? (
          <FormDatePicker name="dataValidade" format="DD/MM/YYYY" />
        ) : (
          <FormDatePicker name="dataValidade" format="DD/MM/YYYY" disabled />
        ),
      width: '15%',
    },
    {
      title: 'Aplicável',
      dataIndex: 'aplicabilidade',
      type: ColumnType.Switch,
      renderEdit: (nome, item) =>
        item.codigoStatus != 3 ? <FormSwitch name="aplicabilidade" /> : <FormSwitch name="aplicabilidade" disabled />,
      width: '5%',
    },
    {
      title: 'Justificativa',
      dataIndex: 'justificativa',
      renderEdit: (nome, item) =>
        item.codigoStatus != 3 ? <FormInput name="justificativa" /> : <FormInput name="justificativa" disabled />,
      width: '20%',
    },
    {
      title: 'Upload',
      renderEdit: (nome, item: any) => (item.codigoStatus != 3 ? <UploadFile hasFile={false} label={' '} /> : <></>),
      width: '5%',
    },
    {
      title: 'Opções',
      width: '15%',
      render: (item: any) => (
        <>
          {hasPermission(['CONTRATO_DOC_ACESSORIA_ENVIAR']) && item.codigoStatus == 1 ? (
            <Tooltip title="Solicitar Avaliação">
              <Button onClick={() => handleSend(item)} icon="messaging-send_file" />
            </Tooltip>
          ) : (
            <></>
          )}
          {hasPermission(['CONTRATO_DOC_ACESSORIA_APROVAR']) && item.codigoStatus == 2 ? (
            <Tooltip title="Aprovar">
              <Button onClick={() => handleApprove(item)} icon="files-check_file_filled2" />
            </Tooltip>
          ) : (
            <></>
          )}
          {hasPermission(['CONTRATO_DOC_ACESSORIA_REPROVAR']) && item.codigoStatus == 2 ? (
            <Tooltip title="Reprovar">
              <Button onClick={() => handleReprove(item)} icon="files-file_delete" />
            </Tooltip>
          ) : (
            <></>
          )}
          {hasPermission(['CONTRATO_DOC_ACESSORIA_REMOVER_ANEXO']) &&
          (item.codigoStatus == 2 || item.codigoStatus == 4 || (item.codigoStatus == 5 && isMRN)) ? (
            <Tooltip title="Remover Anexo">
              {/* <Button onClick={() => handleRemoveFile(item)} icon="files-delete_file" /> */}
              <ButtonDelete
                icon="science-minus"
                confirm="Deseja realmente remover este arquivo?"
                okText="Confirmar"
                title=" "
                onClick={() => handleRemoveFile(item)}
              />
            </Tooltip>
          ) : (
            <></>
          )}
          {item.nomeArquivo && (
            <Tooltip title="Baixar Arquivo">
              <Button
                onClick={() => {
                  handleDownloadFile(item);
                }}
                icon="ui-download"
              />
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      {hasPermission(['CONTRATO_DOC_ACESSORIA_EDITAR']) ? (
        <PerfectScrollbar>
          <InlineEditTable
            updateItem={handleUpdate}
            key={documentoMensalId}
            columns={columns}
            dataSource={documentos}
            pagination={false}
            disablenotification={false}
          />
        </PerfectScrollbar>
      ) : (
        <PerfectScrollbar>
          <Table key={documentoMensalId} columns={columns} dataSource={documentos} pagination={false} />
        </PerfectScrollbar>
      )}
    </>
  );
};

export default TableDocumentoMensal;
